import { Outlet } from "react-router"

const CouponServiceIndexPage=()=>{
    return (<>
        <Outlet />
    </>)

}
export default CouponServiceIndexPage